import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { CustomFieldService } from '../services/custom-field.service';
import { CustomField } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class CustomFieldListResolverService implements Resolve<CustomField[]> {

    constructor(private customFieldService: CustomFieldService) { }

    resolve() {
        const fields: CustomField[] = [];
        return new Promise<CustomField[]>((resolve, reject) => {
            this.customFieldService.list(true).subscribe(
                field => fields.push(field),
                error => reject(error),
                () => resolve(fields)
            );
        });
    }
}
